import {PivotalApiBase} from "./PivotalApiBase";

export default class PivotalFormApi extends PivotalApiBase {

  constructor(baseUrl, apiEnv, apiToken) {
    super(baseUrl, apiEnv, apiToken);
  }

  callFormEndpoint(requestData, envSplit) {
    return this._fetchPostRequest('/rest/forms/formData', requestData, envSplit);
  }

  callFormPutEndpoint(requestData, envSplit) {
    return this._fetchPutRequest('/rest/forms/formData', requestData, envSplit);
  }

  callFormRecuperationEndpoint(requestData, envSplit) {
    return this._fetchPostRequest('/rest/forms/formData/actions/retrieve', requestData, envSplit);
  }

  callFormDeleteEndpoint(requestData, envSplit) {
    return this._fetchDeleteRequest('/rest/forms/formData', requestData, envSplit);
  }

  callFileUploadEndpoint(requestData, envSplit) {
    return this._fetchPostRequest('/rest/attachments/uploads/actions/uploadBase64', requestData, envSplit);
  }
}
